import React, { Component } from 'react'
import { connectStats } from 'react-instantsearch-dom'

class Stats extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const {
      nbHits,
      processingTimeMS,
      nbSortedHits,
      areHitsSorted,
      hitsLeft,
      hitsViewed,
    } = this.props

    if (hitsLeft) {
      return (
        <p>Viewed <span className="transifex-ignore">{hitsViewed > nbHits ? nbHits : hitsViewed}</span> of <span className="transifex-ignore">{nbHits}</span> Products</p>
      )
    } else {
      return <p><span className="transifex-ignore">{nbHits}</span> Product Results </p>
    }
  }
}

const CustomStats = connectStats(Stats)

export default CustomStats
